import React, { FC } from 'react';
import ConfigurationCard from './components/configurationCard';
import { ComponentRendering, isEditorActive, RichText, Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { ProductSeriesDetailConfigurationsOverviewModel } from './models/productSeriesDetailConfigurationsOverview.model';
import { TContentHubSeriesDetailConfigurationsOverviewProps } from './types/productSeriesDetailConfigurationsOverview.types';
import { isEmptyResponse } from '../../utils/checkEmptyResponse';
import useExperiencerEditorPlaceholder from '../../hooks/useExperiencerEditorPlaceholder';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';

const ProductSeriesDetailConfigurationsOverview: FC<TContentHubSeriesDetailConfigurationsOverviewProps> = (props) => {
  const apiResponse = isEmptyResponse(props);
  const model = new ProductSeriesDetailConfigurationsOverviewModel(props);
  const isPlaceholderShown = useExperiencerEditorPlaceholder(props);

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  //  star node opened directly in EE
  if (isPlaceholderShown) {
    return <ExperienceEditorComponentPlaceholder image={model.thumbnailEE} componentName={model.componentName} />;
  }

  // not opened from star node
  // data missing when navigating via from products node
  if (!apiResponse && isEditorActive()) {
    return <EmptyApiDataMessage componentName={model.componentName} />;
  }

  // No data and not in EE
  if (!apiResponse && !isPlaceholderShown && !isEditorActive()) {
    return null;
  }
  return (
    <AnalyticsVisibleEvent rendering={props?.rendering as ComponentRendering} title={model?.title ?? ''} template="Configuration">
      <section>
        <div className="configuration-container" style={{ backgroundColor: model.backgroundColor || '#fff' }}>
          <div className="configuration-container__label-container">
            <Text className="configuration-container__eyebrow" tag="p" field={{ value: model.eyebrow }}></Text>
            <Text className="configuration-container__title" tag="h3" field={{ value: model.title }}></Text>
            <RichText className="configuration-container__description rich-text" tag="div" field={{ value: model.description }}></RichText>
          </div>
          <div className="configuration-container__card-container">
            {model.configurationsOverviewCard?.map((card, index) => (
              <div>
                <ConfigurationCard {...card} key={card?.id} componentNumber={index + 1}></ConfigurationCard>
              </div>
            ))}
          </div>
        </div>
      </section>
    </AnalyticsVisibleEvent>
  );
};
export default withSitecoreContext()(ProductSeriesDetailConfigurationsOverview);
